// extracted by mini-css-extract-plugin
module.exports = {"list":"_3Z6fB","item":"_1hSZ3","backItem":"_3R00w","label":"rDuvw","link":"_3IZG0","span":"_2gKAw","chevron":"_21dtY","forwardChevron":"_3iADV","backChevron":"_3scDa"};